import {  HOME_SECTIONS_LOADER,GET_RECENTLY_VIEW_COLLECTION,RECENTLY_VIEWED_HAS_DATA } from '../../constants/reducerTypes';

const initialState = { searchLoader: true };
const recentlyViewedReducer = (state = initialState, action) => {
  switch (action.type) {
    case HOME_SECTIONS_LOADER:
      return {
        ...initialState
      };
    case GET_RECENTLY_VIEW_COLLECTION:
      return {
        ...state,
        recentlyCollection: action?.payload?.results ? [...action.payload.results] : [],
        clientRecentlyCollection: action?.payload?.clientResults
          ? [...action.payload.clientResults]
          : [],
        recentlyTotalRows: action.payload.recentTotalRows,
        searchLoader: false,
      };
    case RECENTLY_VIEWED_HAS_DATA:
      return {
        ...state,
        isRecentlyViewEmpty: action.payload,
      };
    default:
      return state;
  }
};
export default recentlyViewedReducer;
